(function(){
  function clone(root){
    if(!root||root.dataset.wlMarqueeCloned==='1')return;
    var track=root.querySelector('.wl-marquee-track');
    if(!track||!track.children.length)return;
    root.dataset.wlMarqueeCloned='1';
    var originals=Array.prototype.slice.call(track.children),frag=document.createDocumentFragment();
    originals.forEach(function(node){frag.appendChild(node.cloneNode(true));});
    track.appendChild(frag);
  }
  function schedule(root){
    if(!root||root.dataset.wlMarqueeCloneWatch==='1'||root.dataset.wlMarqueeCloned==='1')return;
    root.dataset.wlMarqueeCloneWatch='1';
    if(!('IntersectionObserver' in window)){clone(root);return;}
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(!entry.isIntersecting)return;
        io.disconnect();
        clone(root);
        var cloned=Array.prototype.slice.call(root.querySelectorAll('.wl-marquee-track > *')).slice(Math.floor(root.querySelectorAll('.wl-marquee-track > *').length/2));
        cloned.forEach(function(node){if(node.classList.contains('wl-obs'))node.classList.add('is-inview');});
      });
    },{rootMargin:'1000px 0px'});
    io.observe(root);
  }
  function boot(scope){(scope||document).querySelectorAll('[data-wl-marquee-clone]').forEach(schedule);}
  boot(document);
  document.addEventListener('shopify:section:load',function(e){boot(e.target);});
})();